import React from "react";

import bucket from "../../../../assets/shapes/webbportal.svg";
import clouds from "../../../../assets/shapes/moln.svg";
import coding from "../../../../assets/shapes/Uppföljning.svg";

import RouteButton from "../../../../components/RouteButton/RouteButton";

import "./Do.css";

const Do = function() {
  return (
    <div>
      <div id="do" className="do">
        <h1 className="doTitle col-12 text-center">Corvivas erbjudande</h1>
        <div className="text-center col-12 col-md-8 col-lg-6 mx-auto">
          <p>
          Digital plattform för enkäter, undersökningar och
           möten riktad till företag och organisationer som arbetar inom
            hälsa och arbetsmiljö. Med Corvivas moderna och flexibla tjänster stärks
             ert erbjudande till kunden samtidigt som automatiserade processer förenklar er vardag!
            </p>
            </div>
        <div className="row">
          <div className="card-group col-12 col-xl-10 offset-xl-1 mx-auto">
            <div className="row">
            <div className="col-12 col-lg-4 col-md-12">
                <div className="card mx-auto text-center">
                  <img className="mx-auto do-img" src={bucket} alt="" />
                  <div className="card-block">
                    <h3 className="card-title">Webbportal</h3>
                    <p className="card-text">
                    I webbportalen får ni tillgång till Corvivas användarvänliga
                     adminprogram för att hantera enkäter, möten, inbjudningar,
                      automatiska påminnelser m.m. Era kundanställda tar del av
                       tjänsterna på portalen och kan med Bank-ID inloggning se
                        sina resultat direkt på webben.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-4 col-md-6">
                <div className="card mx-auto text-center">
                  <img className="mx-auto do-img" src={coding} alt="" />
                  <div className="card-block">
                    <h3 className="card-title">Uppföljning</h3>
                    <p className="card-text">
                    Uppföljning och rapportering ska inte behöva ta tid för er.
                    Individen kan se sina resultat direkt på portalen och ni kan
                     med ett par knapptryck ta fram färdiga grupprapporter till kunden.
                      Texterna i rapporterna anpassas utifrån resultat vilket gör att
                       rapporterna upplevs personliga.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-4 col-md-6">
                <div className="card  mx-auto text-center">
                  <img className="mx-auto do-img" src={clouds} alt="" />
                  <div className="card-block">
                    <h3 className="card-title">MOLNTJÄNST – SAAS</h3>
                    <p className="card-text">
                    Corvivas digitala plattform levereras som molntjänst enligt
                     ”Software As A Service”. Allt som krävs är att ni och era
                      kunder kan surfa in via en webbläsare. Andra fördelar är enklare support,
                       snabbare uppdateringar och att ni slipper dyra licenskostnader.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 do-button-row">
          <RouteButton
            linkTo="/services/scroll"
            buttonText="Jag vill läsa mer"
            class_names="btn btn-corviva"
          />
          <RouteButton
            linkTo="/contact/form"
            buttonText="Jag vill få en demo"
            class_names="btn btn-corviva"
          />
        </div>
      </div>
    </div>
  );
};

export default Do;



// WEBPACK FOOTER //
// ./src/routes/StartPage/components/Do/Do.jsx